import { render, staticRenderFns } from "./DialogListOutlet.vue?vue&type=template&id=00ec4275&lang=html"
import script from "./DialogListOutlet.vue?vue&type=script&lang=js"
export * from "./DialogListOutlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports